import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import { formatCurrency } from 'utils/numberUtilities'

const moneyCell = (props) => {
  return class IconCell extends GridCell {
    render () {
      return (
        <td className='money-cell'>{formatCurrency({ value: this.props.dataItem[this.props.field] })}</td>
      )
    }
  }
}
export {
  moneyCell
}